import { polyfill, trustPolicies } from "https://cdn.kernvalley.us/js/std-js/Sanitizer.js";
export const polyfilled = polyfill();
export { trustPolicies };